import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex 
  flex-col 
  w-full
  space-y-4
  items-start
`);

export const navBtnStyle = ctl(`
  flex
  items-center 
  text-md 
  text-anti-flash-white
`);
